import React from "react";
import styled from "styled-components";

interface OptionCardProps {
  label: string;
  icon?: React.ReactNode;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const OptionCard: React.FC<OptionCardProps> = ({
  label,
  icon,
  selected,
  disabled = false,
  onClick,
}) => (
  <Card
    type="button"
    selected={selected}
    disabled={disabled}
    aria-pressed={selected}
    onClick={onClick}
  >
    {icon && <IconWrapper>{icon}</IconWrapper>}
    <Label>{label}</Label>
  </Card>
);

const Card = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 1 1 0;
  min-width: 0;
  padding: 14px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  border: 1px solid
    ${({ theme, selected }) =>
      selected
        ? theme.globalConstants.color.brandPrimary
        : theme.globalConstants.color.borderGray};
  background: ${({ theme, selected }) =>
    selected
      ? theme.globalConstants.color.backgroundPrimaryLight
      : theme.globalConstants.color.white};
  color: ${({ theme }) => theme.globalConstants.color.brandPrimary};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.globalConstants.color.brandPrimary};
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
`;

const Label = styled.span`
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-size: ${({ theme }) => theme.globalConstants.fontSize.bodySubtle}px;
  font-weight: 500;
  text-align: center;
`;

export default OptionCard;
